//
// NOTE: This component is not recommended for usage as it does not handle keyboard navigation properly.
//
export class NavigationBarComponent {
    private readonly SHOW_CLASS = "show";

    private _buttonsContext: JQuery<HTMLElement> = null;
    private _dropdownsContext: JQuery<HTMLElement> = null;
    private _document: JQuery<Document> = null;

    private _menuItems: Map<JQuery<HTMLElement>, Array<JQuery<HTMLElement>>> = new Map();

    private bindEvents(): void {
        this._menuItems.forEach((items, button) => {
            button.on("click", () => {
                this._dropdownsContext.toggleClass(this.SHOW_CLASS);
                items.forEach(item => item.toggleClass(this.SHOW_CLASS));
            });
        });

        this._document.on("click", (event) => {
            const clickedInsideElement = this._dropdownsContext.get().find(x => x.contains(event.target));
            const clickedButtonElement = this._buttonsContext.get().find(x => x.contains(event.target));
            if (!clickedInsideElement && !clickedButtonElement) {
                this._dropdownsContext.removeClass(this.SHOW_CLASS);
            }
        });
    }

    private parseContext(): void {
        this._document = $(document);
        this._buttonsContext.each((index: number, element: HTMLElement) => {
            const button = $(element);
            const id = button.attr("data-dropdown-id");
            const items = this.getItemsById(id);
            this._menuItems.set(button, items);
        });
    }

    private getItemsById(id: string): Array<JQuery<HTMLElement>> {
        const items = new Array<JQuery<HTMLElement>>();
        this._dropdownsContext.each((index: number, element: HTMLElement) => {
            const item = $(element);
            if (item.attr("data-menu-id") === id) {
                items.push(item);
            }
        });

        return items;
    }

    public init(buttonsContext: JQuery, dropdownsContext: JQuery): void {
        this._buttonsContext = buttonsContext || this._buttonsContext;
        this._dropdownsContext = dropdownsContext || this._dropdownsContext;

        this.parseContext();
        this.bindEvents();
    }

    public static init(context: JQuery, dropdownsContext: JQuery): NavigationBarComponent {
        const component = new NavigationBarComponent();
        component.init(context, dropdownsContext);
        return component;
    }
}
